import getEnv from '@providers/getEnv'

import transports from './transports'

export default transports[getEnv()]
